<template>
  <div class="export__wrapper" v-click-outside="hideExport">
    <button
            @click="toggleSettings"
            class="export-btn"
            :class="{active: settingsVisible}"
            @mouseover="showHelp = true"
            @mouseleave="showHelp = false"
    >
      <BaseIcon icon="export" />{{ $t('buttons.export') }}
        <transition name="fadeUp">
            <div v-if="showHelp && enabledExport === false" class="info-box">
                <div class="triangle"></div>
                <span class="help__paragraph" style="margin-top: 0">
                    {{ $t('tooltips.tentacle_missing') }} <span class="highligh">tentacle</span>
              </span>
            </div>
        </transition>
    </button>
    <transition name="fadeUp">
      <div v-if="settingsVisible" class="export__settings" :class="position">
        <div class="triangle"></div>
        <div class="export__settings__title">
            {{ $t('export.info.first') }}:
          <span>{{ selected.length }}</span>
            {{ 'item' | pluralize(selected.length) }} {{ $t('export.info.second') }}.
          <transition name="fade">
            <span v-if="selected === 0">{{ $t('export.info.rest') }}.</span>
          </transition>
        </div>
        <div class="export__settings__content">
          <div class="export__settings__content__filter">
            <div
              class="button"
              :class="{active: filterType === 'date'}"
              @click="filterType = 'date'"
            >{{ $t('export.tabs.date_range') }}</div>
            <div
              class="button"
              :class="{active: filterType === 'range'}"
              @click="filterType = 'range'"
            >{{ $t('export.tabs.limit_values') }}</div>
            <div class="line" :class="filterType"></div>
          </div>
          <transition name="fade" mode="out-in">
            <div v-if="filterType === 'date'" class="date-range-picker" key="date">
              <date-range-picker
                :locale="mjLocale"
                :from="dateRange.from"
                :to="dateRange.to"
                :past="true"
                :future="false"
                :panel="'range'"
                :yearsCount="1"
                :theme="rangePickerTheme"
                :submitTitle="$t('buttons.apply_range')"
                @select="updateDateRange"
              />
            </div>
            <div v-else-if="filterType === 'range'" class="value-range-picker" key="range">
                <label for="lastvalue">{{ $t('export.limit') }}:</label>
                <input v-model="valueRange" id="lastvalue" type="number" name="lastvalue" value="100" required="required" placeholder="last x..">
            </div>
          </transition>
        </div>
        <div class="export__settings__actions">
          <button @click="exportToXLS" v-tooltip.top="$t('tooltips.excel')">
            <BaseIcon icon="xls" />
          </button>
          <button @click="exportToCSV" v-tooltip.top="$t('tooltips.csv')">
            <BaseIcon icon="csv" />
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import 'vue-mj-daterangepicker/dist/vue-mj-daterangepicker.css';
import { mapGetters } from 'vuex';

export default {
  name: 'Export',
  props: {
    position: {
      type: String,
      default: 'right',
    },
    selected: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showHelp: false,
      settingsVisible: false,
      filterType: 'date',
      limitRange: [0, 100],
      valueRange: 0,
      dateRange: {
        from: '',
        to: '',
      },
      rangePickerTheme: {
        primary: '#b2de4d',
        secondary: '#acb4c5',
        ternary: '#99ce21',
        border: '#eeeeee',
        light: '#ffffff',
        dark: '#363b54',
        hovers: {
          day: '#eeeeee',
          range: '#f5f5f5',
        },
      },
    };
  },
  computed: {
    mjLocale() {
      const locale = this.$i18n.locale.toLowerCase();
      return ['de', 'es', 'en', 'fr', 'ru'].includes(locale) ? locale : 'en';
    },
    ...mapGetters('tentacle', ['user']),
    enabledExport() {
      return (this.selected.length > 0);
    },
  },
  methods: {
    download(server, data) {
      const x = new XMLHttpRequest();
      x.open('GET', `${process.env.VUE_APP_API_URL}/api/v2/export/xls?filter=${JSON.stringify(data)}`, true);
      x.setRequestHeader('Content-type', 'application/json');
      x.setRequestHeader('Authorization', `Bearer ${this.user.token}`);
      x.responseType = 'blob';

      x.onload = (e) => {
        const blob = new Blob([x.response], { type: 'text/vnd.ms-excel; charset=utf-8' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'tentacles.xls';

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
      };
      x.send();
    },
    toggleSettings() {
      if (this.enabledExport) {
        this.settingsVisible = !this.settingsVisible;
      }
    },
    hideExport() {
      this.settingsVisible = false;
    },
    updateDateRange(dates) {
      this.dateRange.from = dates.from;
      this.dateRange.to = dates.to;
    },
    isRangeApplied() {
      if (this.dateRange.from !== null && this.dateRange.to !== null) {
        return true;
      }
      return false;
    },
    modifyDate(value) {
      return `${new Date(value).getFullYear()}-${new Date(value).getMonth() + 1}-${new Date(value).getDate()}`;
    },
    createData() {
      const data = [];
      if (this.filterType === 'date') {
        for (let i = 0; i < this.selected.length; i += 1) {
          data.push({
            id: this.selected[i],
            from: this.modifyDate(this.dateRange.from),
            to: this.modifyDate(this.dateRange.to),
          });
        }
      } else if (this.filterType === 'range') {
        for (let i = 0; i < this.selected.length; i += 1) {
          data.push({
            id: this.selected[i],
            limit: this.valueRange,
          });
        }
      }
      return data;
    },
    exportToXLS() {
      if (this.isRangeApplied()) {
        this.download('192.168.0.104', this.createData());
        this.flash('Data will be downloaded.', 'success');
      } else {
        this.flash('First apply the filter range.', 'info');
      }
    },
    exportToCSV() {
      if (this.isRangeApplied()) {
        this.flash('Will be available soon.', 'warning');
      } else {
        this.flash('First apply the filter range.', 'info');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.export__wrapper {
  margin-left: auto;
  position: relative;
}

.export {
  &__settings {
    position: absolute;
    top: 4.8rem;
    min-height: 18rem;
    display: flex;
    flex-direction: column;
    width: 60rem;
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15), 0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);

    .triangle {
      position: absolute;
      top: -1.2rem;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 0;
      height: 0;
      border-left: 1rem solid transparent;
      border-right: 1rem solid transparent;
      border-bottom: 1.2rem solid white;
    }

    &.left {
      left: 0;

      .triangle {
        left: 4rem;
        right: unset;
      }
    }

    &.right {
      right: 0;

      .triangle {
        right: 4rem;
        left: unset;
      }
    }

    &__title {
      height: 4rem;
      display: flex;
      padding: 1rem;
      align-items: center;
      font-size: 1.2rem;
      font-weight: 500;
      color: $dark;
      span {
        color: darken($company-color, 15%);
        margin: 0 0.5rem;
      }
    }

    &__content {
      flex-grow: 1;

      &__filter {
        width: 100%;
        height: 3rem;
        display: flex;
        align-items: stretch;
        position: relative;
        border-bottom: 1px solid $border-color;

        .button {
          width: 10rem;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          font-weight: 500;
          font-size: 1.2rem;

          color: $grey;
          transition: all 0.3s;

          &:hover,
          &.active {
            color: darken($company-color, 10%);
          }
        }

        .line {
          position: absolute;
          bottom: -0.2rem;
          left: 0;
          width: 10rem;
          height: 0.3rem;
          border-radius: 0.6rem;
          background-color: $company-color;
          transition: all 0.3s;

          &.date {
            transform: translateX(0);
          }

          &.range {
            transform: translateX(100%);
          }
        }
      }
    }

    &__actions {
      display: flex;
      border-top: 0.1rem solid $border-color;
      align-items: stretch;
      height: 4rem;

      button {
        background-color: transparent;
        border: none;
        border-right: 0.1rem solid $border-color;
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc(100% / 2);
        cursor: pointer;

        &:hover {
          .icon {
            fill: darken($company-color, 10%);

            &.danger {
              fill: $danger;
            }
          }
        }

        .icon {
          fill: $grey;
        }
      }
    }
  }
}

.export-btn {
  width: 10rem;
  height: 4.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: $grey;
  border: none;
  background-color: transparent;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: 0.3s all;
    position: relative;

  .icon {
    fill: $grey;
    margin-right: 4px;
  }

  &:hover,
  &.active {
    background-color: $bg;
  }
  .info-box {
    position: absolute;
    top: 6rem;
    right: -3em;
    width: 16rem;
    min-height: 0rem;
    background-color: $dark;
    padding: 1.2rem;
    border-radius: 0.5rem;
    color: $grey;
    box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15), 0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);
    text-align: center;

    .triangle {
        position: absolute;
        top: -1.2rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 0;
        height: 0;
        border-left: 1rem solid transparent;
        border-right: 1rem solid transparent;
        border-bottom: 1.2rem solid $dark;
    }
    .help__paragraph {
        font-weight: 400;
        font-size: 1.1rem;
        line-height: 1.5rem;

        .highligh {
            color: $company-color;
        }
    }
    &__title {
        font-size: 1.3rem;
        color: $company-color;
    }
  }
}

.form-inline {
  display: inline-flex;
  align-items: center;
  margin-right: 1rem;

  input {
    margin: 0 0.5rem;
  }
}

.value-range-picker {
  padding: 3rem;
    display:flex;
    flex-direction: column;
    label {
        font-size: 1.2rem;
        font-weight: 500;
        color: #363B54;
        width:100%;
    }

    input {
        margin-top:1em;
        height: 3.5rem;
        width: 100%;
        max-width: 20em;
        border-radius: 0.5rem;
        border: 2px solid transparent;
        padding: 0 1rem;
        font-size: 1.2rem;
        color: #8c8c94;
        font-weight: 500;
        background: #e5e5e5;
        &:focus  {
            background: transparent;
            border: 2px solid #98c335;
        }
    }
}
</style>

<style lang="scss">
/* customize date-range-picker */
.date-range-picker {
    .mj-daterange-picker-submit {
        display: none !important;
    }
    .mj-daterange-picker-reset {
        margin: auto !important;
    }
  .mj-daterange-picker {
    border: none;
  }

  .mj-daterange-picker .panels-choices .panel-button {
    color: $grey;
    transition: all 0.4s;
    font-weight: 500;
    font-size: 1.2rem;

    &:hover,
    &.is-current {
      color: white;
    }
  }

  .mj-calendar .calendar-days .day.is-selected.is-today span,
  .mj-calendar .calendar-days .day.is-edge-range span {
    color: white;
  }

  .mj-calendar .calendar-days-name .day {
    font-weight: 500;
  }

  .mj-daterange-picker-controls .mj-daterange-picker-button {
    font-weight: 500;
  }

  .mj-calendar .calendar-days .day {
    color: #949db1;
  }

  .mj-calendar .calendar-days .day.is-selected {
    color: white;
  }

  .mj-daterange-picker .preset-ranges .preset label span + span {
    color: $dark;
    font-weight: 500;
    font-size: 1.2rem;
  }
}
</style>
